export default "__VITE_ASSET__Dos8atH8__"